import { API_BASE_URL } from '../config/api';

// Generic fetch wrapper with error handling
const apiFetch = async (endpoint, options = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Failed to fetch ${endpoint}:`, error);
    throw error;
  }
};

// Content API
export const contentAPI = {
  // Get home page content
  getHomeContent: () => apiFetch('/content/home'),
  
  // Get about page content
  getAboutContent: () => apiFetch('/content/about'),
  
  // Get pricing page content
  getPricingContent: () => apiFetch('/content/pricing'),
  
  // Get contact page content
  getContactContent: () => apiFetch('/content/contact'),
  
  // Get blog page content
  getBlogContent: () => apiFetch('/content/blog'),
  
  // Get what we offer page content
  getWhatWeOfferContent: () => apiFetch('/content/what-we-offer'),
  
  // Get testimonials
  getTestimonials: () => apiFetch('/content/testimonials'),
  
  // Get footer content
  getFooterContent: () => apiFetch('/content/footer'),
};

// Product API
export const productAPI = {
  // Get all products
  getProducts: () => apiFetch('/products'),
};

// Contact API
export const contactAPI = {
  // Submit contact form
  submitContactForm: (formData) => 
    apiFetch('/contact', {
      method: 'POST',
      body: JSON.stringify(formData),
    }),
};

// Health check
export const healthAPI = {
  checkHealth: () => apiFetch('/health'),
};

const api = {
  content: contentAPI,
  products: productAPI,
  contact: contactAPI,
  health: healthAPI,
};

export default api;
